var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneColumn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 45.057 45.057",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_33_61_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.76,33.867c-2.154,0-16.309,0-18.465,0c-1.553,0-1.553,2.5,0,2.5c2.156,0,16.311,0,18.465,0 C33.314,36.367,33.314,33.867,31.76,33.867z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.76,25.341c-2.154,0-16.309,0-18.465,0c-1.553,0-1.553,2.5,0,2.5c2.156,0,16.311,0,18.465,0 C33.314,27.841,33.314,25.341,31.76,25.341z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.76,29.382c-2.154,0-16.309,0-18.465,0c-1.553,0-1.553,2.5,0,2.5c2.156,0,16.311,0,18.465,0 C33.314,31.882,33.314,29.382,31.76,29.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.331,11.542c-0.664,0-1.199,0.232-1.199,0.521v10.705c0,0.287,0.535,0.521,1.199,0.521h18.344 c0.666,0,1.201-0.234,1.201-0.521V12.063c0-0.289-0.535-0.521-1.201-0.521H13.331z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.43,0H5.18v45.057h34.697V6.251L33.43,0z M36.878,42.056H8.18V3h23.705v4.76h4.992L36.878,42.056L36.878,42.056z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.76,33.867c-2.154,0-16.309,0-18.465,0c-1.553,0-1.553,2.5,0,2.5c2.156,0,16.311,0,18.465,0 C33.314,36.367,33.314,33.867,31.76,33.867z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.76,25.341c-2.154,0-16.309,0-18.465,0c-1.553,0-1.553,2.5,0,2.5c2.156,0,16.311,0,18.465,0 C33.314,27.841,33.314,25.341,31.76,25.341z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.76,29.382c-2.154,0-16.309,0-18.465,0c-1.553,0-1.553,2.5,0,2.5c2.156,0,16.311,0,18.465,0 C33.314,31.882,33.314,29.382,31.76,29.382z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.331,11.542c-0.664,0-1.199,0.232-1.199,0.521v10.705c0,0.287,0.535,0.521,1.199,0.521h18.344 c0.666,0,1.201-0.234,1.201-0.521V12.063c0-0.289-0.535-0.521-1.201-0.521H13.331z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.43,0H5.18v45.057h34.697V6.251L33.43,0z M36.878,42.056H8.18V3h23.705v4.76h4.992L36.878,42.056L36.878,42.056z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneColumn);
export default __webpack_public_path__ + "static/media/one-column.1f7dc3e09955f86149062e116f609aa3.svg";
export { ForwardRef as ReactComponent };